import React, { Component } from "react";

import { Radio } from "antd";
import { Checkbox } from "semantic-ui-react";

export default class step5 extends Component {
  render() {
    return (
      <div className="col-md-6 mr-auto ml-auto mb-3">
        <h4> What are your immediate priorities?</h4>
        <p>
          (Eg. Funding / User Acquisition / Exchange Listing / Promotion /
          Liquidity )
        </p>
        <div>
          <Checkbox
            label={{ children: "Funding" }}
            onChange={(e, { checked }) => this.props.change("Funding", checked)}
          />
        </div>
        <div>
          <Checkbox
            label={{ children: "User Acquisition" }}
            onChange={(e, { checked }) =>
              this.props.change("User Acquisition", checked)
            }
          />
        </div>
        <div>
          <Checkbox
            label={{ children: "Exchange Listing" }}
            onChange={(e, { checked }) =>
              this.props.change("Exchange Listing", checked)
            }
          />
        </div>
        <div>
          <Checkbox
            label={{ children: " Promotion" }}
            onChange={(e, { checked }) =>
              this.props.change("Promotion", checked)
            }
          />
        </div>
      </div>
    );
  }
}
